import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

/** 스피너 회전 — transform-only, GPU 합성 */
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

/**
 * 지역 상세 응답 대기 중 표시되는 스피너 컨테이너.
 * - flex: 1 로 부모 공간(ContentSection 또는 PageWrapper) 채움
 * - 가운데 정렬 + 적당한 min-height (페이지 전환 시 layout 점프 방지)
 */
export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 240px;
  padding: 48px 0;
`

/**
 * 32px 원형 스피너 — brand orange 호 + light gray 트랙.
 * `border` 트릭으로 SVG 없이 가벼움 (CheckingBody 와 동일 패턴).
 */
export const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 3px solid #f5f5f6;
  border-top-color: #ff5626;
  animation: ${spin} 0.7s linear infinite;
  will-change: transform;
`
